import React from 'react'
import ReactDom from 'react-dom'
import moment from 'moment'

class UnitToolTip extends React.Component {

  constructor(props) {
    super(props)
  }

  shouldComponentUpdate(nextProps, nextState) {
    return nextProps.unit !== this.props.unit
      || nextProps.x !== this.props.x
      || nextProps.y !== this.props.y
  }

  render() {
    const {
      unit,
      x,
      y
    } = this.props

    return (
      <div id="tip" style={{ position: 'fixed', maxWidth: '150px', left: x + 'px', top: y + 'px', opacity: '1' }}>
        <img className="floorplan_image" src={unit.floorplan_image}></img>

        <ul className="floorplan-info">
          <li>
              <span className="unitnumber">Apt {unit.unitnumber}</span>
          </li>
          <li>
              <span className="floorplan_name">{unit.floorplan_name}</span>
          </li>
          <li>
              <span className="bedroomcount">{unit.floorplan_bedroomcount === '0' ? 'Studio' : unit.floorplan_bedroomcount + ' bed'}</span> / <span className="bathroomcount">{parseFloat(unit.floorplan_bathroomcount).toString()} bath</span>
          </li>
          <li>
              <span className="area">{unit.area}</span> Sq. Ft.
          </li>
          <li>
              <span className="price">${parseInt(unit.price)}</span>
          </li>
          <li>
              <span className="dateavailable">Available {unit.available === '2' ? 'Now' : moment(unit.available_date, "YYYY-MM-DD").format("MMM Do") }</span>
          </li>
        </ul>
      </div>
    )
  }
}

export default UnitToolTip
